<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M11,8C11,7.85,10.93,7.720000000000001,10.83,7.63C10.83,7.63,10.83,7.63,10.83,7.63C10.83,7.63,6.83,4.13,6.83,4.13C6.83,4.13,6.83,4.13,6.83,4.13C6.74,4.05,6.63,4,6.5,4C6.22,4,6,4.22,6,4.5C6,4.5,6,11.5,6,11.5C6,11.780000000000001,6.22,12,6.5,12C6.63,12,6.74,11.95,6.83,11.870000000000001C6.83,11.870000000000001,6.83,11.870000000000001,6.83,11.870000000000001C6.83,11.870000000000001,10.83,8.370000000000001,10.83,8.370000000000001C10.83,8.370000000000001,10.83,8.370000000000001,10.83,8.370000000000001C10.93,8.280000000000001,11,8.15,11,8C11,8,11,8,11,8Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'CaretRight',
} as DefineComponent
</script>
